import { createSlice } from '@reduxjs/toolkit';

const postsSlice = createSlice({
  name: 'posts',
  initialState: {
    posts: [],
    totalRows: 0,
    currentUserPostCount: 0, // Total posts by logged-in user
    loading: false,
    error: null,
  },
  reducers: {
    fetchPostsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchPostsSuccess(state, action) {
      state.loading = false;
      state.posts = action.payload.posts;
      state.totalRows = action.payload.totalRows;
      state.currentUserPostCount = action.payload.currentUserPostCount || 0;
    },
    fetchPostsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deletePostSuccess(state, action) {
      const deletedId = action.payload;
      const beforeCount = state.posts.length;
      state.posts = state.posts.filter((post) => post._id !== deletedId && post.id !== deletedId);
      const removed = beforeCount - state.posts.length;
      if (removed > 0) {
        state.totalRows = Math.max(0, state.totalRows - removed);
      }
    },
    bulkDeletePostsSuccess(state, action) {
      const deletedIds = action.payload || [];
      if (!Array.isArray(deletedIds) || deletedIds.length === 0) {
        return;
      }
      const beforeCount = state.posts.length;
      state.posts = state.posts.filter(
        (post) => !deletedIds.includes(post._id) && !deletedIds.includes(post.id)
      );
      const removed = beforeCount - state.posts.length;
      if (removed > 0) {
        state.totalRows = Math.max(0, state.totalRows - removed);
      }
    },
  },
});

// Export the actions
export const {
  fetchPostsStart,
  fetchPostsSuccess,
  fetchPostsFailure,
  deletePostSuccess,
  bulkDeletePostsSuccess,
} = postsSlice.actions;

// Export the reducer as default
export default postsSlice.reducer;
